
    import { initSpinHistory } from "/js/spin-history.js";
    initSpinHistory();
  